module.exports = __webpack_public_path__ + "img/sidebar-empty-list-dark.8f4b40fd.svg";